import React from 'react';

import Link from '@atlaskit/link';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import getMeta from '@atlassian/jira-get-meta';

import { useBanner } from '../../use-banner.tsx';
import messages from './messages.tsx';

const BANNER_ID = 'activate-home-dashboards-banner';

export const ActivateHomeDashboardsBanner = () => {
	const { formatMessage } = useIntl();
	const organizationId = getMeta('ajs-org-id');
	const optInUrl = `https://admin.atlassian.com/o/${organizationId}/townsquare`;

	const homeCommunityPost =
		'https://community.atlassian.com/forums/Atlassian-Home-articles/Home-Dashboards-available-in-open-beta/ba-p/3009544';

	const { isDismissed, handleDismiss } = useBanner(BANNER_ID);

	if (isDismissed || !organizationId) {
		return null;
	}

	return (
		<SectionMessage
			actions={[
				<SectionMessageAction key="dismiss-button" onClick={handleDismiss}>
					{formatMessage(messages.dismissButtonText)}
				</SectionMessageAction>,
			]}
		>
			<FormattedMessage
				{...messages.betaBannerText}
				values={{
					a: (chunks) => <Link href={homeCommunityPost}>{chunks}</Link>,
					b: (chunks) => <Link href={optInUrl}>{chunks}</Link>,
				}}
			/>
		</SectionMessage>
	);
};
